export const VALIDATION_LIMITS = {
  PAGE: {
    TITLE_MAX: 50,
    SEARCH_MAX: 90,
  },
  DOCUMENT: {
    DESCRIPTION_MAX: 50,
  },
  TEMPLATE: {
    TITLE_MAX: 90,
    NAME_MAX: 90,
  },
  COURSE: {
    TITLE_MAX: 90,
  },
};

export const VALIDATION_MESSAGES = {
  maxChars: (max: number): string => `Must be at most ${max} characters`,
  required: (field: string): string => `${field} is required`,
};
